<template>
  <div>
    <h1>Conundrum Preview</h1>
  </div>
</template>

<script>
export default {
  name: 'ConundrumPreview',
}
</script>